export const SECURITY_CONTROLS = [
  'SECURITY_CONTROL',
  'PASSPORT_CONTROL'
]

export const LINKS = [
  'CONTROL_LINK',
  'TRAIN_LINK'
]

export const PUBLIC_TRANSPORT = [
  'TRAIN',
  'BUS'
]
export const ONEWAY = [
  'ONEWAY_OPENING'
]

export const TYPES_HIDDEN_NO_LINKS = [
  ...PUBLIC_TRANSPORT,
  ...SECURITY_CONTROLS,
  ...ONEWAY
]

export const TYPES_HIDDEN = [
  ...TYPES_HIDDEN_NO_LINKS,
  ...LINKS
]

const SHARED_TYPES = {
  TRAIN: 'Tren_T.svg',
  METRO: 'Metro_T.svg',
  BUS: 'Bus-grande_T.svg',
  SECURITY_CONTROL: 'seguridad-t.svg',
  PASSPORT_CONTROL: 'cruza-el-control-de-pasaporte-JJ.svg',
  ONEWAY_OPENING: 'pasillo_sin_retorno.svg'
}

export default {
  /**
   * Head on, start the route.
   */
  0: {
    action: 'HEAD_ON',
    defaultIcon: 'Continua-recto-JJ.svg',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Finish the route.
   */
  1: {
    action: 'FINISH_THE_ROUTE',
    defaultIcon: 'Tu-destino-esta-enfrente-JJ.svg',
    types: {
      ...SHARED_TYPES,
      ON_THE_LEFT: 'Tu-destino-esta-a-la-izquierda-JJ.svg',
      ON_THE_RIGHT: 'Tu-destino-esta-a-la-derecha-JJ.svg'
    }
  },
  /**
   * Continue along the given street, do not turn.
   */
  2: {
    action: 'CONTINUE_ALONG_THE_GIVEN_STREET,_DO_NOT_TURN',
    defaultIcon: 'Continua-recto-JJ.svg',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Go straight.
   */
  3: {
    action: 'GO_STRAIGHT',
    defaultIcon: 'Continua-recto-JJ.svg',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Turn right.
   */
  4: {
    action: 'TURN_RIGHT',
    defaultIcon: 'Gira-a-la-derecha-JJ.svg',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Do an u-turn.
   */
  5: {
    action: 'DO_AN_U-TURN',
    defaultIcon: '',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Turn left.
   */
  6: {
    action: 'TURN_LEFT',
    defaultIcon: 'Gira-a-la-izquierda-JJ.svg',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Reached given via point. If this is the final point, FINISH action is used instead.,
   */
  7: {
    action: 'REACHED_GIVEN_VIA_POINT',
    defaultIcon: 'Tu-destino-esta-enfrente-JJ.svg',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Enter roundabout.
   */
  8: {
    action: 'ENTER_ROUNDABOUT',
    defaultIcon: '',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Leave roundabout.
   */
  9: {
    action: 'LEAVE_ROUNDABOUT',
    defaultIcon: '',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Continue along the roundabout.
   */
  10: {
    action: 'CONTINUE_ALONG_THE_ROUNDABOUT',
    defaultIcon: '',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Start at the end of the street.
   */
  11: {
    action: 'START_AT_THE_END_OF_THE_STREET',
    defaultIcon: '',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Enter street while moving against the allowed direction.
   */
  12: {
    action: 'ENTER_STREET_WHILE_MOVING_AGAINST_THE_ALLOWED_DIRECTION',
    defaultIcon: '',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Leave the street while moving against the allowed direction.
   */
  13: {
    action: 'LEAVE_THE_STREET_WHILE_MOVING_AGAINST_THE_ALLOWED_DIRECTION',
    defaultIcon: '',
    types: {
      ...SHARED_TYPES
    }
  },
  /**
   * Go up.
   */
  14: {
    action: 'GO_UP',
    changeAction: true,
    changeFloor: true,
    hidden: true,
    defaultIcon: 'Sube-por-la-escalera-JJ.svg',
    types: {
      ...SHARED_TYPES,
      'ELEVATOR': 'Toma-el-ascensor-y-sube-JJ.svg',
      'ESCALATOR_M': 'Sube-por-la-escalera-mecanica-JJ.svg',
      'ESCALATOR_O': 'Sube-por-la-escalera-JJ.svg',
      'RAMP': 'Asciende-por-la-rampa-JJ.svg',
      'ROLLING_CORRIDOR': 'Asciende-por-la-rampa-JJ.svg'
    }
  },
  /**
   * Go down.
   */
  15: {
    action: 'GO_DOWN',
    changeAction: true,
    changeFloor: true,
    hidden: true,
    defaultIcon: 'Baja-por-la-escalera-JJ.svg',
    types: {
      ...SHARED_TYPES,
      'ELEVATOR': 'Toma-el-ascensor-y-baja-JJ.svg',
      'ESCALATOR_M': 'Baja-por-la-escalera-mecanica-JJ.svg',
      'ESCALATOR_O': 'Baja-por-la-escalera-JJ.svg',
      'RAMP': 'Desciende-por-la-rampa-JJ.svg',
      'ROLLING_CORRIDOR': 'Desciende-por-la-rampa-JJ.svg'
    }
  },
  /**
   * Wait.
   */
  16: {
    action: 'WAIT',
    defaultIcon: '',
    removable: true,
    types: {
      ...SHARED_TYPES
    }
  }
}
